// colorUtils.ts

export function isColorDark(hexColor: string): boolean {
    // Remove "#" if present
    const hex = hexColor.replace('#', '');
  
    // Validate hex length
    if (hex.length !== 6) {
      throw new Error('Invalid hex color format. Expected format: #RRGGBB');
    }
  
    // Convert hex to RGB values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
  
    // Calculate luminance using ITU-R BT.601
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  
    // Return true if dark, false if light
    return luminance < 128;
  }
  